<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="tempo_ign_off" class="col-sm-2 control-label">TEMPO PARADO (seg):</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.tempo_ign_off" class="form-control input-sm" id="tempo_ign_off">
            </div>
            <label for="tempo_ign_on" class="col-sm-2 control-label">TEMPO DIRIGINDO (seg):</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.tempo_ign_on"  class="form-control" id="tempo_ign_on" >
            </div>
        </div>
        <!--
        <div class="form-group">
            <label for="heartbeat_accon" class="col-sm-2 control-label">KeepAlive Ligado:</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.heartbeat_accon" class="form-control" id="heartbeat_accon">
            </div>
            <label for="heartbeat_accoff" class="col-sm-2 control-label">KeepAlive Desligado:</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.heartbeat_accoff"  class="form-control" id="heartbeat_accoff" >
            </div>
        </div>
        -->
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-4">
                <button @click="send()" type="button" class="btn btn-xs btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
            <div class="col-sm-4">

            </div>
            <div class="col-sm-2">

                <div class="dropup">
                    <button class="btn btn-xs btn-block btn-default dropdown-toggle" type="button" id="dropdownMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        <i class="fa fa-list-alt"></i> AÇÕES
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuList">
                        <li>
                            <button @click="sendAll()" type="button" class="btn btn-xs btn-success">
                                <i class="fa fa-save"></i> ENVIAR COMANDOS PARA TODOS
                            </button>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </form>
</template>
<script>
    import {Suntech, Concox} from "../../../../class";
    import {Bus} from '../../../../class/bus';
    export default {
        name: "TemposBws",
        props: {
            config: {
                default: null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Concox.sendTempos(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            },
            sendAll () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração para todos?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Concox.sendTemposAll(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
